import { StyledCard } from '@app/components/card/Card';
import { PageMeta } from '@app/components/meta/Meta';

export const TooManyRequests = () => {
	return (
		<>
			<PageMeta title="Too Many Requests" />

			<StyledCard style={{ width: '100%', maxWidth: 680 }}>
				<h1 className="h2">Too Many Requests</h1>
				<p>
					It seems that you have made too many requests. You will need to wait a short
					while before you can access the site again.
				</p>
			</StyledCard>
		</>
	);
};

export default TooManyRequests;
